import actionCreatorFactory from "typescript-fsa";

import { normalizeActions } from "@ea/shared_components/redux/common.actions";
import {
  createDataModuleActions,
  createTableActionsGetter,
} from "@ea/shared_components/redux/common.data.actions";
import { ScriptChangelog } from "@ea/shared_types/types";

const actionCreator = actionCreatorFactory("SCRIPT_CHANGELOG_MODULE");

export const moduleActions = createDataModuleActions<ScriptChangelog>(actionCreator);
export const getScriptChangelogTableActions = createTableActionsGetter(
  normalizeActions(moduleActions.table),
);
export const scriptChangelogActions = {
  ...normalizeActions(moduleActions.data),
};
export const scriptChangelogActionCreators = {
  ...moduleActions,
};
